import React from "react";

import { VisibilityContext } from "react-horizontal-scrolling-menu";
import LeftArrow from "../../../components/SVGComponents/LeftArrow";
import RightArrow from "../../../components/SVGComponents/RightArrow";
import { CUSTOM_STYLES, DEFAULT_SORT_COLUMNS, TABS, STUDY_SEARCH_RESULTS_ID } from "../../../constants/Constants";

export function LeftArrowFunction() {
  const {
    isFirstItemVisible,
    scrollPrev,
    visibleItemsWithoutSeparators,
    getPrevElement,
    scrollToItem,
    visibleElements,
    initComplete
  } = React.useContext(VisibilityContext);

  const [disabled, setDisabled] = React.useState(
    //!visibleItemsWithoutSeparators.length && isFirstItemVisible
    !initComplete || (initComplete && isFirstItemVisible)
  );
  React.useEffect(() => {
    // NOTE: detect if whole component visible
    if (visibleElements.length) {
      setDisabled(isFirstItemVisible);
    }else{
      setDisabled((prev)=>!prev);
    }
  }, [isFirstItemVisible, visibleElements]);
  const clickHandler = () => scrollToItem(getPrevElement(), "smooth", "start");
  return (
   
    <div className="left-arrow-css"  onClick={clickHandler} 
    style={{cursor:disabled?'not-allowed':'pointer'}}
    //style={{display:disabled?'none':'flex'}}
    >
        <LeftArrow active={!disabled}/>
    </div>
  );
}

export function RightArrowFunction() {
  const {
    isLastItemVisible,
    scrollNext,
    visibleItemsWithoutSeparators,
    getNextElement,
    scrollToItem,
    visibleElements
  } = React.useContext(VisibilityContext);

  const [disabled, setDisabled] = React.useState(
    // !visibleItemsWithoutSeparators.length && isLastItemVisible
    !visibleElements.length && isLastItemVisible
  );
  React.useEffect(() => {
    if (visibleElements.length) {
      setDisabled(isLastItemVisible);
    }else{
      setDisabled((prev)=>!prev);
    }
  }, [isLastItemVisible, visibleElements]);
  const clickHandler = () => scrollToItem(getNextElement(), "smooth", "end");
  return (

    <div  onClick={clickHandler} className="right-arrow-css" 
    style={{cursor:disabled?'not-allowed':'pointer'}}
    //style={{visibility:disabled?'hidden':'visible'}}
    >
        <RightArrow active={!disabled}/>
    </div>

    // <Arrow disabled={disabled} onClick={() => scrollNext()}>
      
    // </Arrow>
  );
}

export const getCurrentId = (id) => {
  if (id == "study_1") {
    return "unreported"
  } else if(id == "study_26") {
    return "draft"
  } else if(id == "study_2") {
    return "saved"
  }else if(id == "study_3") {
    return "reported"
  }else if(id == "study_4") {
    return "closed"
  }else if(id == "study_5") { 
    return "qcreview"
  }else if(id == "study_24") {
    return "qcreviewAssigned"
  }else if(id == "study_6") {
    return "qcfix"
  }else if(id == "study_7") {
    return "qcverify"
  }else if(id == "study_8") {
    return "returned"
  }else if(id == "study_9") {
    return "critical"
  }else if(id == "study_10") {
    return "library"
  }else if(id == "study_11") {
    return "normal"
  }else if(id == "study_12"){
    return "normalwithfb";
  }else if(id == "study_13"){
    return "abnormal";
  }else if(id == "study_14") {
    return "reviewAssigned"
  }else if(id == "study_15") {
    return "reviewComplete"
  }else if(id == "study_16"){
    return "evaluationAssigned";
  }else if(id == "study_17"){
    return "evaluationComplete";
  }else if(id == "study_18"){
    return "pending";
  }else if(id == "study_19"){
    return "approved";
  }else if(id == "study_20"){
    return "rejected";
  }else if(id == "study_21"){
    return "reviewPending";
  }else if(id == "study_22"){
    return "positive";
  }else if(id == "study_23"){
    return "negative";
  }else if(id == "study_25"){
    return "reported";
  }  else if(id == "study_27"){
    return "unreportedUnassigned";
  }else if(id == "study_28"){
    return "preliminaryUnassigned";
  }else if(id == "study_29"){
    return "preliminaryReadyForReview";
  }else if(id == "study_search_results"){
    return "all";
  }
  
}

export const TABS_WITH_SPECIFIC_SORT = ['study_3', 'study_5', 'study_6', 'study_7', 'study_22', 'study_23', 'study_24', 'study_25', 'study_14', 'study_15', 'study_16', 'study_17', 'study_18', 'study_19', 'study_20','study_26', 'study_27'];

export const ALL_TABS_ALLOWED_SORT_COLUMNS = new Set([
  "emergency_status",
  "patient_name",
  "patient_id",
  "study_date",
  "modality_name",
  "client_name",
  "study_description",
  "assignment_created_date",
  "reporting_provider",
]);

export const onTabSelect = (event, data, tabDetails, setSelectedValue,themeName,setSortGlobal,sortGlobal) => {
  
  const sortMapping = {
    study_3: "report_submitted_date",
    study_5: "emergency_status",
    study_24: "emergency_status",
    study_6: "emergency_status",
    study_7: "emergency_status",
    study_22: "report_submitted_date",
    study_23: "report_submitted_date",
    study_25: "report_submitted_date",
    study_14: "review_assigned_date",
    study_15: "review_completed_date",
    study_16: "evaluation_assigned_date",
    study_17: "evaluation_completion_date",
    study_18: "requested_date",
    study_19: "approved_date",
    study_20: "requested_date2"
  };

  if (data.value === STUDY_SEARCH_RESULTS_ID) {
    if (!ALL_TABS_ALLOWED_SORT_COLUMNS.has(sortGlobal.sortColumn)) {
      setSortGlobal((prev) => ({
        ...prev,
        sortColumn: "assignment_created_date",
        sortOrder: "desc",
      }));
    }
  } else if (DEFAULT_SORT_COLUMNS.has(sortGlobal.sortColumn)) {
    let newSortColumn = null;

    const isPreferenceDefaultColumn = sortGlobal.sortColumn === "assignment_created_date" || sortGlobal.sortColumn === "emergency_status";
    if (data.value in sortMapping && (sortGlobal.sortOrder === "desc" || isPreferenceDefaultColumn)) {
      newSortColumn = sortMapping[data.value];
      console.log(`--- Setting global filter for ${newSortColumn} ----`);
    } else if (Object.values(sortMapping).includes(sortGlobal.sortColumn)) {
      newSortColumn = "assignment_created_date";
      console.log("--- Resetting global filter to assignment_created_date ----");
    }

    if (newSortColumn) {
      setSortGlobal((prev) => ({
        ...prev,
        sortColumn: newSortColumn,
        sortOrder: "desc",
      }));
    }
  }

  //console.log("Thmeme name ",getCurrentId(data.value));
  let currentTab = data.value;
  if(themeName != "light"){
    document.getElementById(currentTab).style.border = CUSTOM_STYLES.ACTIVE_TAB;
    document.getElementById(currentTab).style.background = "unset";
  }else if(themeName === "light") {
    document.getElementById(currentTab).style.background =
    TABS.ACTIVE_BACKGROUND;
  }
  document.getElementById(currentTab).style.borderRadius =
    "10px 10px 0px 0px";
  document.getElementById(currentTab).style.borderBottom =
    "1px solid rgba(0,0,255,0.1)";
  
  for (let i = 0; i < tabDetails.length; i++) {
    if (tabDetails[i].show === true && tabDetails[i].id !== currentTab) {
      console.log("Deselecting tab ", i, tabDetails[i].id);
      let tabElement = document.getElementById(tabDetails[i].id);
      
      if (tabElement) {
        tabElement.style.border = "";
        tabElement.style.borderRadius = "";
        tabElement.style.borderBottom = "";
        tabElement.style.background = "";
      } else {
        console.log("Element not found:", tabDetails[i].id);
      }
    }
  }
  console.log("-- Tab Value --",data.value);
  setSelectedValue(data.value);
};

export const handleCXRBorderChange = (currentTab,tabDetails,themeName) => {
  if(themeName != "light"){
    document.getElementById(currentTab).style.border =
    "1px solid rgba(255,255,255,0.3)";
  }else{
    document.getElementById(currentTab).style.border =
    "1px solid #d0d0d0";
  }
  document.getElementById(currentTab).style.borderRadius =
    "10px 10px 0px 0px";
  document.getElementById(currentTab).style.borderBottom =
    "1px solid rgba(0,0,255,0.1)";
    console.log("---- Tab Value ---",tabDetails);
  for (let i = 1; i <= tabDetails.length; i++) {
    if (tabDetails[i-1].show == true && currentTab.charAt(currentTab.length - 1) != i && getNumber(currentTab) != i) {
      // console.log("going in ",i);
      document.getElementById(`study_${i}`).style.border = "";
      document.getElementById(`study_${i}`).style.borderRadius = "";
      document.getElementById(`study_${i}`).style.borderBottom = "";
    }
  }
}

function getNumber(str){
  const txt = str.split('_').pop();
  return parseInt(txt, 10);
}


export const updateDto = (dto,id,pageIndex,sortColumn,sortOrder, selectedValue) => {
  if (id == "unreported") {
    dto["unreportedStudiesPage"] = pageIndex + 1;
    dto["dptk_unreportedstudiestab_sortColumn"] = sortColumn;
    dto["dptk_unreportedstudiestab_sortOrder"] = sortOrder;
  } else if(id == "draft") {
    dto["draftStudiesPage"] = pageIndex + 1;
    dto["dptk_draftstudiestab_sortColumn"] = sortColumn;
    dto["dptk_draftstudiestab_sortOrder"] = sortOrder;
  } else if(id == "saved") {
    dto["savedStudiesPage"] = pageIndex + 1;
    dto["dptk_savedstudiestab_sortColumn"] = sortColumn;
    dto["dptk_savedstudiestab_sortOrder"] = sortOrder;
  } else if(id == "reviewPending") {
    dto["reviewPendingStudiesPage"] = pageIndex + 1;
    dto["dptk_reviewPendingstudiestab_sortColumn"] = sortColumn;
    dto["dptk_reviewPendingstudiestab_sortOrder"] = sortOrder;
  } else if(id == "returned") {
    dto["returnedStudiesPage"] = pageIndex + 1;
    dto["dptk_returnedstudiestab_sortColumn"] = sortColumn;
    dto["dptk_returnedstudiestab_sortOrder"] = sortOrder;
  }else if(id == "critical") {
    dto["criticalStudiesPage"] = pageIndex + 1;
    dto["dptk_criticalstudiestab_sortColumn"] = sortColumn;
    dto["dptk_criticalstudiestab_sortOrder"] = sortOrder;
  }else if(id == "reported") {
    dto["reportedStudiesPage"] = pageIndex + 1;
    dto["dptk_reportedstudiestab_sortColumn"] = sortColumn;
    dto["dptk_reportedstudiestab_sortOrder"] = sortOrder;
  }else if(id == "positive") {
    dto["positiveStudiesPage"] = pageIndex + 1;
    dto["dptk_positivestudiestab_sortColumn"] = sortColumn;
    dto["dptk_positivestudiestab_sortOrder"] = sortOrder;
  }else if(id == "negative") {
    dto["negativeStudiesPage"] = pageIndex + 1;
    dto["dptk_negativestudiestab_sortColumn"] = sortColumn;
    dto["dptk_negativestudiestab_sortOrder"] = sortOrder;
  }else if(id == "closed") {
    dto["closedStudiesPage"] = pageIndex + 1;
    dto["dptk_closedstudiestab_sortColumn"] = sortColumn;
    dto["dptk_closedstudiestab_sortOrder"] = sortOrder;
  }else if(id == "qcreview") {
    dto["qcreviewStudiesPage"] = pageIndex + 1;
    dto["dptk_qcreviewstudiestab_sortColumn"] = sortColumn;
    dto["dptk_qcreviewstudiestab_sortOrder"] = sortOrder;
  }else if(id == "qcreviewAssigned") {
    dto["qcreviewAssignedStudiesPage"] = pageIndex + 1;
    dto["dptk_qcreviewAssignedstudiestab_sortColumn"] = sortColumn;
    dto["dptk_qcreviewAssignedstudiestab_sortOrder"] = sortOrder;
  }else if(id == "qcfix") {
    dto["qcfixStudiesPage"] = pageIndex + 1;
    dto["dptk_qcfixstudiestab_sortColumn"] = sortColumn;
    dto["dptk_qcfixstudiestab_sortOrder"] = sortOrder;
  }else if(id == "qcverify") {
    dto["qcverifyStudiesPage"] = pageIndex + 1;
    dto["dptk_qcverifystudiestab_sortColumn"] = sortColumn;
    dto["dptk_qcverifystudiestab_sortOrder"] = sortOrder;
  }else if(id == "returned") {
    dto["returnedStudiesPage"] = pageIndex + 1;
    dto["dptk_returnedstudiestab_sortColumn"] = sortColumn;
    dto["dptk_returnedstudiestab_sortOrder"] = sortOrder;
  }else if(id == "critical") {
    dto["criticalStudiesPage"] = pageIndex + 1;
    dto["dptk_criticalstudiestab_sortColumn"] = sortColumn;
    dto["dptk_criticalstudiestab_sortOrder"] = sortOrder;
  }else if(id == "library") {
    dto["libraryStudiesPage"] = pageIndex + 1;
    dto["dptk_librarystudiestab_sortColumn"] = sortColumn;
    dto["dptk_librarystudiestab_sortOrder"] = sortOrder;
  }else if(id == "normal") {
    dto["normalStudiesPage"] = pageIndex + 1;
    dto["dptk_normalstudiestab_sortColumn"] = sortColumn;
    dto["dptk_normalstudiestab_sortOrder"] = sortOrder;
  }else if(id == "normalwithfb") {
    dto["normalwithfbStudiesPage"] = pageIndex + 1;
    dto["dptk_normalwithfbstudiestab_sortColumn"] = sortColumn;
    dto["dptk_normalwithfbstudiestab_sortOrder"] = sortOrder;
  }else if(id == "abnormal") {
    dto["abnormalStudiesPage"] = pageIndex + 1;
    dto["dptk_abnormalstudiestab_sortColumn"] = sortColumn;
    dto["dptk_abnormalstudiestab_sortOrder"] = sortOrder;
  }else if(id == "reviewAssigned") {
    dto["reviewAssignedStudiesPage"] = pageIndex + 1;
    dto["dptk_reviewAssignedstudiestab_sortColumn"] = sortColumn;
    dto["dptk_reviewAssignedstudiestab_sortOrder"] = sortOrder;
  }else if(id == "reviewComplete") {
    dto["reviewCompleteStudiesPage"] = pageIndex + 1;
    dto["dptk_reviewCompletestudiestab_sortColumn"] = sortColumn;
    dto["dptk_reviewCompletestudiestab_sortOrder"] = sortOrder;
  }else if(id == "evaluationAssigned") {
    dto["evaluationAssignedStudiesPage"] = pageIndex + 1;
    dto["dptk_evaluationAssignedstudiestab_sortColumn"] = sortColumn;
    dto["dptk_evaluationAssignedstudiestab_sortOrder"] = sortOrder;
  }else if(id == "evaluationComplete") {
    dto["evaluationCompleteStudiesPage"] = pageIndex + 1;
    dto["dptk_evaluationCompletestudiestab_sortColumn"] = sortColumn;
    dto["dptk_evaluationCompletestudiestab_sortOrder"] = sortOrder;
  }else if(id == "pending") {
    dto["pendingStudiesPage"] = pageIndex + 1;
    dto["dptk_pendingstudiestab_sortColumn"] = sortColumn;
    dto["dptk_pendingstudiestab_sortOrder"] = sortOrder;
  }else if(id == "approved") {
    dto["approvedStudiesPage"] = pageIndex + 1;
    dto["dptk_approvedstudiestab_sortColumn"] = sortColumn;
    dto["dptk_approvedstudiestab_sortOrder"] = sortOrder;
  } else if(id == "rejected") {
    dto["rejectedStudiesPage"] = pageIndex + 1;
    dto["dptk_rejectedstudiestab_sortColumn"] = sortColumn;
    dto["dptk_rejectedstudiestab_sortOrder"] = sortOrder;
  } else if(id == "all") {
    dto["allStudiesPage"] = pageIndex + 1;
    dto["dptk_allstudiestab_sortColumn"] = sortColumn;
    dto["dptk_allstudiestab_sortOrder"] = sortOrder;
  }
  return dto;
}

export const handleSucessDataAndCount = (id,response,data,totalCount) => {
  if (id == "unreported") {
      data = response.data.data.unreportedStudies.searchResults;
      totalCount = response.data.data.unreportedStudies.totalRecords;
  } else if(id == "draft") {
    data = response.data.data.draftStudies.searchResults;
    totalCount = response.data.data.draftStudies.totalRecords;
  } else if(id == "saved") {
    data = response.data.data.savedStudies.searchResults;
    totalCount = response.data.data.savedStudies.totalRecords;
  } else if(id == "reviewPending") {
    data = response.data.data.reviewPendingStudies.searchResults;
    totalCount = response.data.data.reviewPendingStudies.totalRecords;
  } else if(id == "reported") {
    data = response.data.data.reportedStudies.searchResults;
    totalCount = response.data.data.reportedStudies.totalRecords;
  }else if(id == "positive") {
    data = response.data.data.positiveStudies.searchResults;
    totalCount = response.data.data.positiveStudies.totalRecords;
  }else if(id == "negative") {
    data = response.data.data.negativeStudies.searchResults;
    totalCount = response.data.data.negativeStudies.totalRecords;
  }else if(id == "closed") {
    data = response.data.data.closedStudies.searchResults;
    totalCount = response.data.data.closedStudies.totalRecords;
  }else if(id == "qcreview") {
    data = response.data.data.qcreviewStudies.searchResults;
    totalCount = response.data.data.qcreviewStudies.totalRecords;
  }else if(id == "qcreviewAssigned") {
    data = response.data.data.qcreviewAssignedStudies.searchResults;
    totalCount = response.data.data.qcreviewAssignedStudies.totalRecords;
  }else if(id == "qcfix") {
    data = response.data.data.qcfixStudies.searchResults;
    totalCount = response.data.data.qcfixStudies.totalRecords;
  }else if(id == "qcverify") {
    data = response.data.data.qcverifyStudies.searchResults;
    totalCount = response.data.data.qcverifyStudies.totalRecords;
  }else if(id == "returned") {
    data = response.data.data.returnedStudies.searchResults;
    totalCount = response.data.data.returnedStudies.totalRecords;
  }else if(id == "critical") {
    data = response.data.data.criticalStudies.searchResults;
    totalCount = response.data.data.criticalStudies.totalRecords;
  }else if(id == "library") {
    data = response.data.data.libraryStudies.searchResults;
    totalCount = response.data.data.libraryStudies.totalRecords;
  }else if(id == "normal") {
    data = response.data.data.normalStudies.searchResults;
    totalCount = response.data.data.normalStudies.totalRecords;
  }else if(id == "normalwithfb") {
    data = response.data.data.normalwithfbStudies.searchResults;
    totalCount = response.data.data.normalwithfbStudies.totalRecords;
  }else if(id == "abnormal") {
    data = response.data.data.abnormalStudies.searchResults;
    totalCount = response.data.data.abnormalStudies.totalRecords;
  }else if(id == "reviewAssigned") {
    data = response.data.data.reviewAssignedStudies.searchResults;
    totalCount = response.data.data.reviewAssignedStudies.totalRecords;
  }else if(id == "reviewComplete") {
    data = response.data.data.reviewCompleteStudies.searchResults;
    totalCount = response.data.data.reviewCompleteStudies.totalRecords;
  }else if(id == "evaluationAssigned") {
    data = response.data.data.evaluationAssignedStudies.searchResults;
    totalCount = response.data.data.evaluationAssignedStudies.totalRecords;
  }else if(id == "evaluationComplete") {
    data = response.data.data.evaluationCompleteStudies.searchResults;
    totalCount = response.data.data.evaluationCompleteStudies.totalRecords;
  }else if(id == "pending") {
    data = response.data.data.pendingStudies.searchResults;
    totalCount = response.data.data.pendingStudies.totalRecords;
  }else if(id == "approved") {
    data = response.data.data.approvedStudies.searchResults;
    totalCount = response.data.data.approvedStudies.totalRecords;
  }else if(id == "rejected") {
    data = response.data.data.rejectedStudies.searchResults;
    totalCount = response.data.data.rejectedStudies.totalRecords;
  }else if(id == "all") {
    data = response.data.data.allStudies?.searchResults;
    totalCount = response.data.data.allStudies?.totalRecords;
  }
  return {data: data,totalCount: totalCount}
}

export const handleDropDownClick = (e, data, setSortGlobal,sortGlobal,setChangeToDropSorting) => {
  console.log("Sorting clicked");
  console.log(data);
  setChangeToDropSorting(false);
  setSortGlobal((prev) => {
    const isSameColumn = prev.sortColumn === data.key;
    const newItem = { ...prev, sortColumn: data.key };
    if (data.key === "emergency_status") {
      newItem.sortOrder = "desc";
    } else if (isSameColumn) {
      newItem.sortOrder = prev.sortOrder == "asc" ? "desc" : "asc";
    } else {
      newItem.sortOrder = "desc";
    }
    return newItem;
  });
};

export const handleDropDownClickCustom = (e, data, setSortGlobal,sortGlobal,setChangeToDropSorting,sortOrderCustom) => {
  console.log("Sorting clicked");
  console.log(data);
  setChangeToDropSorting(false);
  setSortGlobal(() => {
    const newItem = { ...sortGlobal };
    newItem.sortColumn = data.key;
    newItem.sortOrder = sortOrderCustom ? 'asc' : 'desc';
    return newItem;
  });
};

export const clearSort = (setSortGlobal,sortGlobal,setChangeToDropSorting) => {
  setChangeToDropSorting(true);
  // setSortGlobal(() => {
  //   const newItem = { ...sortGlobal };
  //   // newItem.sortOrder = "";
  //   // newItem.sortColumn = "";
  //   return newItem;
  // });
};

export const changeSortDir = (setSortGlobal,sortGlobal,setChangeToDropSorting) => {
  setChangeToDropSorting(false);
  setSortGlobal(() => {
    const newItem = { ...sortGlobal };
    if (newItem.sortOrder == "asc") {
      newItem.sortOrder = "desc";
    } else {
      newItem.sortOrder = "asc";
    }
    return newItem;
  });
};

export const getActiveTabId = (obj) => {
  console.log("---- Object ---",obj);
    const filterKey = Object.keys(obj).filter((key) => obj[key].show == true);
    let returnValue = null;
    for(const key in obj){
      if(key == filterKey){
        returnValue = obj[key];
      }
    }
   
    // console.log("---- Active Tab Obj ----", returnValue);
    return returnValue;
}

export function capitalizeFullName(fullName) {
    return fullName;
  if (typeof fullName !== 'string' || !fullName.trim()) {
    return fullName; // Return input if it's not a string or if it's empty
  }

  var nameParts = fullName.trim().split(' ');

  var capitalizedNameParts = nameParts.map(function (namePart) {
    return namePart.charAt(0).toUpperCase() + namePart.slice(1).toLowerCase();
  });

  return capitalizedNameParts.join(' ');
}


